import React from 'react';
import './FormattedJsonDetails.css';
import FormattedArray from '../FormattedJsonViewer/FormattedArray';

const FormattedJsonDetails = (props) => {

    let lineClass = "formattedjsonviewer-line";
    let titleWidth = 0;
    let dataToDisplay = "";

    if (Array.isArray(props.data)) {
        props.data.forEach(element => {
            if(element.ArrayItems != undefined){
                if(element.Label !== null && element.Label !== undefined && element.Label.length > titleWidth && element.ArrayItems !== null && element.ArrayItems.length !== 0){
                    titleWidth = element.Label.length;
                }
            }
            else {
                if(element.Label !== null && element.Label !== undefined && element.Label.length > titleWidth){
                    titleWidth = element.Label.length;
            }        
        }
        });
        dataToDisplay = props.data;
    }
    else 
    {
        dataToDisplay = Object.entries(props.data).map(([key, value]) => ({ Label: key, Contents: value }));
    }


    let labelWidth = titleWidth > 30 ? "formattedjsondetails-label-wide" : "formattedjsondetails-label";

    return (
        <div>
            {dataToDisplay.map((element, index) => {
                const divider = element.Label === null ? "" : ":";
                lineClass = "formattedjsondetails-line" ;

                if (Array.isArray(element.ArrayItems)) {
                    return(<FormattedArray data={element.ArrayItems} title={element.Label} titleWidth={titleWidth}></FormattedArray>)
                } else if (Array.isArray(element.ChildItems)) {
                    return(
                        <div key={index}>
                            <div className={lineClass}>
                                <div className={labelWidth}>{element.Label}{divider}</div>
                                <div className="formattedjsondetails-item">
                                    <FormattedJsonDetails data={element.ChildItems} title={element.Label} titleWidth={titleWidth}></FormattedJsonDetails>
                                </div>
                            </div>
                        </div>
                    )
                } else {
                    let contents = element.Contents;
                    return(
                        <div key={index}>
                            {contents !== undefined && contents !== null && contents !== "null" &&
                            contents !== '' && contents.length > 0 ? (
                                <div className={lineClass}>
                                    <div className={labelWidth}>{element.Label}{divider}</div>
                                    <div className="formattedjsondetails-item">{contents}</div>
                                </div>
                            ) : (null) }
                        </div>
                    )
                }
            })}
        </div>
    );
};
  
export default FormattedJsonDetails;